import React from 'react'
import styled from 'styled-components'
import { TreeView, TreeViewNode } from '../TreeView/TreeView'
import { Checkbox, CheckboxProps } from '../../controls/Checkbox/Checkbox'

const Wrapper = styled.div``

type Option = {
  id: string
  title: string
  isChecked?: boolean

  options?: Option[]
}

type Props = {
  options: Option[]
  expandAll?: boolean
  onChange: (id: string) => void
}

const mapOptions = (options: Option[], onChange: (id: string) => void, lvl = 0): TreeViewNode[] => {
  return options.map((option: Option) => {
    const checkedChildOptionsCount =
      option.options && option.options.reduce((acc: number, o: Option) => (o.isChecked ? acc + 1 : acc), 0)

    const allChildOptionsChecked = checkedChildOptionsCount && checkedChildOptionsCount === option.options?.length
    const isPartlyChecked =
      option.options && checkedChildOptionsCount && checkedChildOptionsCount !== option.options.length
    const isChecked = option.isChecked || isPartlyChecked || allChildOptionsChecked

    return {
      id: option.id,
      props: {
        value: option.id,
        label: option.title,
        isChecked,
        isPartlyChecked,
        disabled: lvl === 0 && !option.options?.length,
        onChange,
      },
      nodes: option.options && mapOptions(option.options, onChange, lvl + 1),
    }
  })
}

export const CheckboxTree: React.FC<Props> = ({ options, expandAll, onChange }: Props) => {
  const nodes = mapOptions(options, onChange)

  return (
    <Wrapper>
      <TreeView
        nodes={nodes}
        expandAll={expandAll}
        itemComponent={(props: CheckboxProps) => (
          <div onClick={e => e.stopPropagation()}>
            <Checkbox {...props} />
          </div>
        )}
      />
    </Wrapper>
  )
}
